import { useMemo } from 'react'

import { differenceInDays, parseISO } from 'date-fns'

import { Appointment } from '../../../models/appointment/Appointment'
import { SearcherType, TriageSearch, TriageSearchStatus } from '../../../models/searchForCare/SearchForCare'

/**
 * Returns any in progress search or completed search that has not led to an appointment
 */
export const useInProgressSearch = (
  searches: TriageSearch[],
  appointments?: Appointment[] | [],
  isChildSearch: boolean = false,
) => {
  const inProgressSearch = useMemo(() => {
    const searchIds = new Set<string>()
    appointments?.forEach((appt) => {
      if (appt?.searchId) {
        searchIds.add(appt.searchId)
      }
    })

    return searches.find((search) => {
      const searchDate = search?.update_date ?? search?.create_date
      const daysSinceSearchUpdate = differenceInDays(new Date(), searchDate ? parseISO(searchDate) : new Date())
      // For most inProgressSearches we would use an adult search, however, starting a new search on a child booking flow requires child searches.

      const whoAmISearchingFor = isChildSearch ? search?.body?.type : search?.body?.type === SearcherType.ADULT
      const status = search.triage_status
      const isCompletedSearchWithNoAppt = status === TriageSearchStatus.COMPLETED && !searchIds.has(search.id)
      const isNotProgramAwareSearch =
        search?.body?.programPreference == undefined && search?.body?.clientSelectedTopic == undefined
      return (
        (status === TriageSearchStatus.IN_PROGRESS || isCompletedSearchWithNoAppt) &&
        isNotProgramAwareSearch &&
        whoAmISearchingFor &&
        daysSinceSearchUpdate <= 7
      )
    })
  }, [appointments, searches, isChildSearch])

  return inProgressSearch
}
